import { HelmetDexteel } from "@dexteel/mesf-core";
import { NewRollsReport } from "./components/NewRollsReport";

export const NewRollsPage = () => {
	return (
		<>
			<HelmetDexteel title="New Rolls" />
			<NewRollsReport />
		</>
	);
};
